import { latestMovies } from '@/mocks/movies';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function LatestMovies() {
  return (
    <section id="movies" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <SectionHeading
          tag="最新电影"
          title="近期上线的院线新片与口碑佳作"
          desc="按上线时间整理的最新电影，涵盖剧情、科幻、悬疑、动画等多种类型，每部都附上简介与评分，方便快速挑选。"
        />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {latestMovies.map((movie) => (
            <article
              key={movie.id}
              className="group bg-background-100/70 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors"
            >
              <div className="relative w-full h-[210px] sm:h-[250px] lg:h-[290px]">
                <img
                  src={movie.poster}
                  alt={`电影《${movie.title}》海报`}
                  title={`${movie.title} ${movie.genres.join(' ')} 在线观看`}
                  className="w-full h-full object-cover"
                />
                <span className="absolute top-2 left-2 px-2 py-1 rounded-md bg-foreground-950/70 text-background-50 text-xs font-semibold">
                  {movie.rating.toFixed(1)}
                </span>
                <span className="absolute top-2 right-2 px-2 py-1 rounded-md bg-primary-500/90 text-background-50 text-[11px] font-medium">
                  {movie.year}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 truncate">
                  {movie.title}
                </h3>
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1 mt-1.5 text-[11px] md:text-xs text-foreground-500">
                  <span>{movie.region}</span>
                  <span className="w-0.5 h-0.5 rounded-full bg-foreground-300"></span>
                  <span>{movie.duration}</span>
                </div>
                <div className="flex flex-wrap gap-1.5 mt-2.5">
                  {movie.genres.map((g) => (
                    <span
                      key={g}
                      className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px]"
                    >
                      {g}
                    </span>
                  ))}
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed mt-3 line-clamp-2">
                  {movie.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}